import "./low_resolution_label.scss"

